import axios from "axios"
import { authAPI } from "./user/userAPI"
// import { setCookie } from 'react-cookie'

const $host = axios.create({
    baseURL: process.env.REACT_APP_API_URL
})

const $authHost = axios.create({
    withCredentials: true,
    baseURL: process.env.REACT_APP_API_URL
})

const authInterceptor = config => {
    config.headers.authorization = `Bearer ${localStorage.getItem('token')}`
    return config
}

$authHost.interceptors.request.use(authInterceptor)

$authHost.interceptors.response.use(
    (config) => {
        return config
    }, 
    async (error) => {
        const originalRequest = error.config // тот запрос, который был во время 401 (не авторизирован). Его повторим снова

        if (error.response.status == 401 && error.config && !error.config._isRetry) {
            originalRequest._isRetry = true

            try {
                const response = await axios.get(process.env.REACT_APP_API_URL + 'api/users/auth', {
                    withCredentials: true,
                    headers: {
                        authorization: `Bearer ${localStorage.getItem('token')}`
                    }
                })
                localStorage.setItem('token', response.data.accessToken)
                return $authHost.request(originalRequest)
            } catch (e) {
                console.log('Не авторизований')
            }
            if (!window.location.href.includes('/login')) {
                window.location.replace(process.env.REACT_APP_FRONTEND_URL + 'login');
            }
            // window.location.replace(process.env.REACT_APP_ADMIN_URL + 'login');
        } else {
            // Ось тут додав, щоб виходило коли людину заблокували
            // localStorage.removeItem('token')
            // if (!window.location.href.includes('/login')) {
            //     window.location.replace(process.env.REACT_APP_FRONTEND_URL + 'login');
            // }
        }
        throw error
    }
)

export {
    $host,
    $authHost,
}